import styled from "styled-components";

export const HeroSec = styled.div`
  color: #fff;
  height: 100%;
  background: #140e0e;
`;
